import { Box, Toolbar } from "@mui/material";
import WelcomeBanner from "../common/WelcomeBanner";
import React, { useContext, useEffect } from "react";
import TopBar from "../topBar/TopBar";
import Sidebar from "../sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import sizeConfigs from "../../configs/sizeConfigs";
import { getUserDetails } from "../../services/userService";
import { AuthContext } from "../../core/authContext";
import "./styles.scss";
import { setUserDetails } from "../../redux/features/userDetailsSlice";
import { useDispatch } from "react-redux";
import { UserDetailsType } from "../../types/genericType";

const MainLayout = () => {
  const [initials, setInitials] = React.useState("");
  const dispatch = useDispatch();
  const { user }: any = useContext(AuthContext);
  const userId = user?.sub;

  useEffect(() => {
    getUserDetails(parseInt(userId ?? ""))
      ?.then((res) => {
        if (res) {
          const firstIntial = res.firstName?.charAt(0);
          const lastIntial = res.lastName?.charAt(0);
          firstIntial &&
            lastIntial &&
            setInitials(`${firstIntial}${lastIntial}`);
          const userDetails: UserDetailsType = {
            id: res.id,
            firstName: res.firstName,
            lastName: res.lastName,
            email: res.email,
            isActive: res.isActive,
            role: res.role,
            accounts: res.accounts,
            statements: res.statements,
            clientInfo: res.clientInfo,
          };
          dispatch(setUserDetails({ userDetails }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userId]);

  return (
    <Box className="main-layout-container">
      <TopBar initials={initials} />
      <Box
        component="nav"
        className="sidebar-nav"
        sx={{ width: sizeConfigs.sidebar.width }}
      >
        <Sidebar />
      </Box>
      <Box
        component="main"
        className="main-content"
        sx={{ width: `calc(100% - ${sizeConfigs.sidebar.width})` }}
      >
        <Toolbar />
        <Box sx={{ my: 2 }}>
          <WelcomeBanner />
        </Box>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
